export default __webpack_public_path__ + "static/media/SPORT 100 ELS_2.e62e5403.webp";